// src/shared/components/ui/button.tsx
import React from 'react'
import clsx from 'classnames'

export type ButtonVariant = 'default' | 'outline' | 'ghost'
export type ButtonSize = 'sm' | 'md' | 'lg'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
}

/**
 * A simple tailwind-styled button.
 */
export function Button({
  variant = 'default',
  size = 'md',
  className,
  ...props
}: ButtonProps) {
  const base = 'pac-glass-btn inline-flex items-center justify-center font-medium rounded-md focus:outline-none'
  const variants: Record<ButtonVariant,string> = {
    default: 'text-neutral-100 hover:text-neon_purple-400 hover:border-neon_purple-500',
    outline: 'text-neutral-100 hover:text-neon_orange-400 hover:border-neon_orange-500',
    ghost:   'text-neutral-100 hover:text-neon_green-400 hover:border-neon_green-500 border-transparent',
  }
  const sizes: Record<ButtonSize,string> = {
    sm: 'px-2 py-1 text-sm',
    md: 'px-3 py-2 text-base',
    lg: 'px-4 py-3 text-lg',
  }
  
  return (
    <button
      className={clsx(base, variants[variant], sizes[size], className)}
      {...props}
    />
  )
}
